import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {FlexModule} from "@angular/flex-layout";
import {FormControl, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatIcon} from "@angular/material/icon";
import {MatError, MatFormField, MatInput, MatSuffix} from "@angular/material/input";
import {MatTabLabel} from "@angular/material/tabs";
import {PanelType} from "../../../../../../../../nter-ui-kit/src/lib/webkit/components/info-panel/info-panel.component";
import {AngularModule} from "../../../../../core/modules/angular.module";
import {AppSharedModule} from "../../../../../core/modules/app-shared.module";
import {DateUtilsService} from "../../../../../shared/services/dateUtils.service";

@Component({
  selector: 'app-shared-space-selection-list',
  standalone: true,
  imports: [
    AppSharedModule,
    FlexModule,
    MatIcon,
    MatTabLabel,
    MatFormField,
    MatInput,
    AngularModule,
    ReactiveFormsModule,
    MatSuffix,
    MatError
  ],
  templateUrl: './shared-space-selection-list.component.html',
  styleUrl: '../../space-selection-list/space-selection-list.component.scss'
})
export class SharedSpaceSelectionListComponent {
  @Input() availableSpace: {
    totalSpace: number,
    availableSpace: number
  } = {totalSpace: 0, availableSpace: 0};
  @Input() subLeaseSize: number = 0;
  @Input() listHeight: string = '530px';
  @Input() warnOnUnavailableSelection: boolean = true;

  reservedSpaceControl: FormControl<number | null> = new FormControl<number | null>(null);

  @Output() onSpaceSizeChange = new EventEmitter<number>();

  constructor(public dateUtils: DateUtilsService) {
    this.reservedSpaceControl = new FormControl<number | null>(this.subLeaseSize, [Validators.required, Validators.min(0.001)]);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['availableSpace']) {
      this.reservedSpaceControl = new FormControl<number | null>(this.subLeaseSize,
        [Validators.required, Validators.min(0.001), Validators.max(this.warnOnUnavailableSelection ? this.availableSpace.availableSpace : this.availableSpace.totalSpace)]);
      this.reservedSpaceControl.updateValueAndValidity();

      this.reservedSpaceControl.valueChanges.subscribe((value) => {
        if (value !== null) {
          this.onSpaceSizeChange.emit(value);
        }
      });
    }

    if (changes['subLeaseSize']) {
      this.reservedSpaceControl.setValue(this.subLeaseSize, { emitEvent: false });
    }
  }

  get unavailableSpaceSelected() {
    if (this.reservedSpaceControl.value == null) return false;
    return this.reservedSpaceControl.value > this.availableSpace.availableSpace;
  }

  get errorMessage() {
    return this.reservedSpaceControl.hasError('required') ? 'Value is required' :
      this.reservedSpaceControl.hasError('min') ? 'Space size must be greater than 0' :
        this.reservedSpaceControl.hasError('max') ? this.exceedSpaceMessage :
          '';
  }

  get exceedSpaceMessage(): string {
    return this.warnOnUnavailableSelection ?
      'Reserved space cannot exceed available space' :
      'Reserved space cannot exceed parent lease space';
  }

  protected readonly PanelType = PanelType;
}
